import React from 'react';
import './richContext.scss';

interface LocationRowProps {
  locationLabel: string;
}

const LocationRow: React.FC<LocationRowProps> = ({ locationLabel }) => {
  return (
    <div className="rc-location-row">
      <span className="rc-signal-icon">📍</span>
      <span className="rc-location-label">{locationLabel}</span>
    </div>
  );
};

export default LocationRow;
